/** True when the event target is a form field or rich-text editor — skip global hotkeys. */
export function isEditableTarget(target: EventTarget | null): boolean {
  if (!target || !(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  return !!target.closest('input, textarea, select, [contenteditable="true"], [role="textbox"]');
}

/** True when this keydown is going to a field, even if focus and target disagree. */
export function eventTargetIsEditable(e: KeyboardEvent): boolean {
  if (isEditableTarget(e.target)) return true;
  if (typeof document !== 'undefined' && isEditableTarget(document.activeElement)) return true;
  if (typeof e.composedPath === 'function') {
    for (const node of e.composedPath()) {
      if (isEditableTarget(node)) return true;
    }
  }
  return false;
}

/** True when a known modal overlay is open that should block hub quick search. */
export function isHubQuickSearchGloballyBlocked(): boolean {
  if (typeof document === 'undefined') return false;
  if (document.body.classList.contains('tc-popout-open')) return true;
  if (document.querySelector('.pdf-viewer-modal, .image-viewer-modal, .lqs-overlay, .hqs-overlay')) return true;
  return false;
}
